(function () {
  function setupRegionSwitcher(root) {
    if (!root) return;

    var button = root.querySelector('.region-switcher__button');
    var popover = root.querySelector('.region-switcher__popover');
    if (!button || !popover) return;

    var isOpen = false;

    function open() {
      if (isOpen) return;
      isOpen = true;
      popover.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', handleDocClick);
      document.addEventListener('keydown', handleKeydown);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      popover.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', handleDocClick);
      document.removeEventListener('keydown', handleKeydown);
    }

    function handleDocClick(event) {
      if (!root.contains(event.target)) {
        close();
      }
    }

    function handleKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        close();
        button.focus();
      }
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      isOpen ? close() : open();
    });

    // Remember last picked country in localStorage (non-authoritative)
    var options = popover.querySelectorAll('.region-switcher__option');
    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var code = option.getAttribute('data-region-option');
        try {
          window.localStorage && localStorage.setItem('preferred_country', code);
        } catch (e) {
          // ignore storage errors
        }
        // form submit proceeds as normal
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-region-switcher]');
    if (!roots.length) return;
    roots.forEach(setupRegionSwitcher);
  });
})();
